/* Coco 9 UX — scroll reveal (fail-safe).
   Nothing is hidden unless this script hides it, and it only hides elements that
   are below the fold at load. Anything on screen, added later, filtered in, or on a
   page loaded in a hidden/background tab stays plainly visible. */
(function(){
  var SEL='.c9-pc,.cc-card,.prod-card,.cat-tile,.tile,.loc-card,[data-reveal]';
  var d=document;
  function run(){
    var rm=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var vh=window.innerHeight||0;
    if(rm||!('IntersectionObserver' in window)||d.hidden||!vh){return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting){return;}
        var el=e.target;
        io.unobserve(el);
        var p=el.parentElement;
        var i=p?Array.prototype.indexOf.call(p.children,el):0;
        var delay=(i%8)*55;
        el.style.transitionDelay=delay+'ms';
        el.classList.add('c9-in');
        /* hand the element back to the theme's own hover/transition styles */
        setTimeout(function(){
          el.classList.remove('c9-rv','c9-in');
          el.style.transitionDelay='';
        },delay+650);
      });
    },{threshold:.04});
    Array.prototype.forEach.call(d.querySelectorAll(SEL),function(el){
      if(el.hidden||el.offsetParent===null){return;}
      if(el.getBoundingClientRect().top<vh){return;}
      el.classList.add('c9-rv');
      io.observe(el);
    });
  }
  if(d.readyState!=='loading'){run();}else{d.addEventListener('DOMContentLoaded',run);}
})();

/* Sticky "Add to bag" bar for phones (product pages).
   Appears once the real Add button has scrolled out of view; mirrors its label/price
   and disabled state; tapping it uses the REAL button so every existing check still
   runs (occasion, flavour count, cake message...). If the form still needs something
   (invalid field or a disabled button) it scrolls the customer to the form instead. */
(function(){
  var d=document;
  function run(){
    var form=d.querySelector('main form[data-add-to-cart-form]');
    var real=form&&form.querySelector('[data-add-btn]');
    if(!form||!real||!('IntersectionObserver' in window)) return;
    var title=(d.querySelector('main h1')||{}).textContent||'';
    var bar=d.createElement('div');
    bar.className='c9-atc';bar.setAttribute('aria-hidden','true');
    bar.innerHTML='<div class="c9-atc__txt"><span class="c9-atc__name"></span><span class="c9-atc__price"></span></div><button type="button" class="c9-atc__btn" tabindex="-1">Add to bag</button>';
    d.body.appendChild(bar);
    var nameEl=bar.querySelector('.c9-atc__name'),priceEl=bar.querySelector('.c9-atc__price'),btn=bar.querySelector('.c9-atc__btn');
    nameEl.textContent=title.trim();
    function sold(){return /sold out|unavailable/i.test(real.textContent);}
    function sync(){
      var p=real.querySelector('[data-add-price]');
      priceEl.textContent=p?p.textContent.trim().replace(/\.00$/,''):'';
      btn.textContent=real.disabled?(sold()?'Sold out':'Choose options'):'Add to bag';
      btn.disabled=real.disabled&&sold();
      var t=((d.querySelector('main h1')||{}).textContent||'').trim();
      if(t){ nameEl.textContent=t.replace(/\s*\((Serves|serves)[^)]*\)\s*$/,''); var sv=/\((Serves [^)]*)\)/.exec(t); if(sv&&priceEl.textContent) priceEl.textContent=priceEl.textContent+' \u00b7 '+sv[1]; }
    }
    /* the first thing the customer still has to choose */
    function pending(){
      var groups=form.querySelectorAll('[data-gc-group][data-gc-required]');
      for(var i=0;i<groups.length;i++){ if(!groups[i].querySelector('[aria-pressed="true"]')) return groups[i]; }
      return form.querySelector(':invalid')||form.querySelector('[data-fp]')||real;
    }
    sync();
    new MutationObserver(sync).observe(real,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled']});
    var realVisible=true,footerVisible=false;
    /* P5 (audit): the bar shows whenever the real button is out of view in
       EITHER direction — readers of the details and FAQs keep the buy action. */
    function show(){var on=!realVisible&&!footerVisible;bar.classList.toggle('is-on',on);bar.setAttribute('aria-hidden',on?'false':'true');btn.tabIndex=on?0:-1;}
    new IntersectionObserver(function(es){realVisible=es[0].isIntersecting;show();}).observe(real);
    var foot=d.querySelector('footer');
    if(foot)new IntersectionObserver(function(es){footerVisible=es[0].isIntersecting;show();}).observe(foot);
    btn.addEventListener('click',function(){
      if(real.disabled||form.querySelector(':invalid')||form.querySelector('[data-gc-group][data-gc-required="true"]:not(:has([aria-pressed="true"]))')){
        var target=pending();
        target.scrollIntoView({behavior:'smooth',block:'center'});
        target.classList.add('c9-atc-flash');setTimeout(function(){target.classList.remove('c9-atc-flash');},1600);
        var focusable=target.matches&&target.matches('input,select,textarea,button')?target:target.querySelector('button,input,select,textarea');
        if(focusable)setTimeout(function(){focusable.focus({preventScroll:true});},450);
        return;
      }
      real.click();
    });
  }
  if(d.readyState!=='loading'){run();}else{d.addEventListener('DOMContentLoaded',run);}
})();

/* Component parity (2026-09-19) — two small behaviours the prototype had and V7 lacked.
   1. Header shadow once the page scrolls (prototype .hdr.c9-scrolled).
   2. Add-to-bag loading state: the cart drawer's submit handler swaps the label to
      "Adding…" and disables the button; mark it aria-busy so coco9-ux.css shows a
      full-strength button with a spinner (not a faded "disabled" one), and keep the
      phone sticky bar saying "Adding…" instead of "Choose options". Read-only on the
      form: nothing here changes what is submitted or when. */
(function(){
  var d=document;
  function run(){
    var hdr=d.querySelector('.c9-hdr');
    if(hdr){
      var ticking=false;
      var paint=function(){ticking=false;hdr.classList.toggle('c9-scrolled',(window.scrollY||window.pageYOffset)>4);};
      paint();
      window.addEventListener('scroll',function(){if(!ticking){ticking=true;window.requestAnimationFrame(paint);}},{passive:true});
    }
    var btns=d.querySelectorAll('main form[action*="/cart/add"] [type="submit"], main [data-add-btn]');
    if(!btns.length||!('MutationObserver' in window)) return;
    Array.prototype.forEach.call(btns,function(b){
      function check(){
        var busy=b.disabled&&/^\s*adding/i.test(b.textContent||'');
        if(busy){b.setAttribute('aria-busy','true');}else if(b.hasAttribute('aria-busy')){b.removeAttribute('aria-busy');}
        var sticky=d.querySelector('.c9-atc__btn');
        if(busy&&sticky&&b.hasAttribute('data-add-btn')){sticky.textContent='Adding…';}
      }
      new MutationObserver(check).observe(b,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled']});
      check();
    });
  }
  if(d.readyState!=='loading'){run();}else{d.addEventListener('DOMContentLoaded',run);}
})();

/* =====================================================================
   COCO 9 V2 — SITE CHROME  (sections/header.liquid, 2026-09-19)
   Header mega menus, open-now pill, search overlay (Shopify predictive
   search, products only), mobile menu drawer, bag count badge.
   - The bag button is a[data-open-cart]; snippets/cart-drawer.liquid owns the
     drawer and opens it from ANY [data-open-cart] click (document-level). Nothing
     here touches the cart. Without JS the bag link goes to /cart.
   - Overlays are moved to <body> so the sticky header's stacking context can't
     trap them under page content. Theme-editor reloads re-initialise cleanly.
   - Body scroll lock is a class on <html> (c9h-lock), so it never fights the
     cart drawer's own body.style.overflow.
   ===================================================================== */
(function(){
  var d=document,html=d.documentElement,W=window;
  var FOC='a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var RM=W.matchMedia&&W.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var current=null;               /* the open overlay element, if any */
  var timers={};                  /* pill intervals per section */

  function vis(el){return !!(el.offsetWidth||el.offsetHeight||el.getClientRects().length);}
  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function setExpanded(el,on){
    if(!el||!el.id) return;
    Array.prototype.forEach.call(d.querySelectorAll('[aria-controls="'+el.id+'"]'),function(t){t.setAttribute('aria-expanded',on?'true':'false');});
  }

  /* ---------- overlay controller (search + mobile menu) ---------- */
  function openLayer(el,focusEl,trigger){
    if(!el) return;
    if(current&&current!==el) closeLayer(current,false);
    el._c9hRet=trigger||d.activeElement;
    el.hidden=false;
    current=el;
    html.classList.add('c9h-lock');
    setExpanded(el,true);
    W.requestAnimationFrame(function(){W.requestAnimationFrame(function(){el.dataset.open='true';});});
    setTimeout(function(){if(focusEl&&current===el){try{focusEl.focus({preventScroll:true});}catch(e){focusEl.focus();}}},RM?0:60);
  }
  function closeLayer(el,restore){
    if(!el||el.hidden) return;
    el.dataset.open='false';
    if(current===el){current=null;html.classList.remove('c9h-lock');}
    setExpanded(el,false);
    setTimeout(function(){if(el.dataset.open!=='true') el.hidden=true;},RM?0:300);
    if(restore){
      var r=el._c9hRet;
      if(!r||!d.contains(r)||!vis(r)||(current&&current.contains(r))){r=d.querySelector('.c9h-burger');if(r&&!vis(r))r=d.querySelector('.c9h-ic--search');}
      if(r&&r.focus) setTimeout(function(){r.focus();},RM?0:20);
    }
  }
  function trap(e,root){
    var panel=root.querySelector('[role="dialog"]')||root;
    var f=Array.prototype.filter.call(panel.querySelectorAll(FOC),vis);
    if(!f.length) return;
    var first=f[0],last=f[f.length-1],a=d.activeElement;
    if(!panel.contains(a)){e.preventDefault();first.focus();return;}
    if(e.shiftKey&&a===first){e.preventDefault();last.focus();}
    else if(!e.shiftKey&&a===last){e.preventDefault();first.focus();}
  }
  function searchEl(){return d.querySelector('[data-c9h-search]');}
  function menuEl(){return d.querySelector('[data-c9h-menu]');}
  function openSearch(trigger){
    var s=searchEl(); if(!s) return;
    openLayer(s,s.querySelector('[data-c9h-q]'),trigger);
  }
  function openMenu(trigger){
    var m=menuEl(); if(!m) return;
    openLayer(m,m.querySelector('button[data-c9h-menu-close]'),trigger);
  }

  /* ---------- delegated triggers (bound once) ---------- */
  d.addEventListener('click',function(e){
    var t=e.target.closest?e.target:null; if(!t) return;
    var so=t.closest('[data-c9h-search-open]');
    if(so){e.preventDefault();var fromMenu=current&&current===menuEl();openSearch(fromMenu?d.querySelector('.c9h-burger'):so);return;}
    var mo=t.closest('[data-c9h-menu-open]');
    if(mo){e.preventDefault();openMenu(mo);return;}
    var mc=t.closest('[data-c9h-menu-close]');
    if(mc){closeLayer(menuEl(),!mc.hasAttribute('data-open-cart'));return;}
    var sc=t.closest('[data-c9h-search-close]');
    if(sc){closeLayer(searchEl(),true);return;}
    var g=t.closest('[data-c9h-grp]');
    if(g){
      var open=g.getAttribute('aria-expanded')!=='true';
      var body=g.closest('.c9h-mnav__body');
      Array.prototype.forEach.call(body?body.querySelectorAll('[data-c9h-grp]'):[g],function(b){
        var on=(b===g)&&open,sub=d.getElementById(b.getAttribute('aria-controls'));
        b.setAttribute('aria-expanded',on?'true':'false');
        if(sub) sub.hidden=!on;
        if(b.parentNode) b.parentNode.classList.toggle('is-open',on);
      });
      return;
    }
    /* tap outside an open mega menu (touch) closes it */
    if(!t.closest('.c9h-item--mega')){
      Array.prototype.forEach.call(d.querySelectorAll('.c9h-item--mega.is-open'),function(it){closeItem(it);});
    }
  });
  d.addEventListener('keydown',function(e){
    if(current){
      if(e.key==='Escape'){e.preventDefault();closeLayer(current,true);return;}
      if(e.key==='Tab'){trap(e,current);}
      return;
    }
    if(e.key==='Escape'){
      var it=d.activeElement&&d.activeElement.closest?d.activeElement.closest('.c9h-item--mega'):null;
      var hov=d.querySelector('.c9h-item--mega:hover,.c9h-item--mega.is-open');
      it=it||hov;
      if(it){shutItem(it);var l=it.querySelector('.c9h-item__link');if(l&&it.contains(d.activeElement))l.focus();}
    }
  });

  /* ---------- mega menus ---------- */
  function openItem(it){
    Array.prototype.forEach.call(d.querySelectorAll('.c9h-item--mega.is-open'),function(o){if(o!==it)closeItem(o);});
    it.classList.remove('is-shut');it.classList.add('is-open');
    var l=it.querySelector('.c9h-item__link');if(l)l.setAttribute('aria-expanded','true');
  }
  function closeItem(it){
    it.classList.remove('is-open','is-shut');
    var l=it.querySelector('.c9h-item__link');if(l)l.setAttribute('aria-expanded','false');
  }
  function shutItem(it){closeItem(it);it.classList.add('is-shut');}
  /* A mega panel left open while the page scrolls under it is disorienting —
     the header is sticky, the panel is not the thing you are reading. Shut
     every open panel on the first scroll; hovering again reopens it. */
  var scrollShut=false;
  window.addEventListener('scroll',function(){
    if(scrollShut) return; scrollShut=true;
    Array.prototype.forEach.call(d.querySelectorAll('.c9h-item--mega.is-open,.c9h-item--mega:hover'),shutItem);
    setTimeout(function(){scrollShut=false;},250);
  },{passive:true});
  function initMega(root){
    var hoverNone=W.matchMedia&&W.matchMedia('(hover: none)');
    Array.prototype.forEach.call(root.querySelectorAll('.c9h-item--mega'),function(it){
      var link=it.querySelector('.c9h-item__link');
      it.addEventListener('mouseenter',function(){it.classList.remove('is-shut');if(link)link.setAttribute('aria-expanded','true');});
      it.addEventListener('mouseleave',function(){closeItem(it);});
      it.addEventListener('focusin',function(){if(!it.classList.contains('is-shut')&&link)link.setAttribute('aria-expanded','true');});
      it.addEventListener('focusout',function(e){if(!it.contains(e.relatedTarget))closeItem(it);});
      /* touch screens wide enough for the desktop nav: first tap opens, second tap follows the link */
      if(link) link.addEventListener('click',function(e){
        if(hoverNone&&hoverNone.matches&&!it.classList.contains('is-open')){e.preventDefault();openItem(it);}
      });
    });
  }

  /* ---------- Occasions lid preview (snippets/c9h-occasions-item.liquid) ----------
     The mega panel's open/close/hover/focus already comes free from initMega above
     (same .c9h-item--mega shell). This only swaps which lettered-lid photo shows:
     hovering or focusing a .c9h-occ__link reveals the <img>/plain-lid tile whose
     data-c9h-occ-for matches that link's data-c9h-occ-key (both "" when an occasion
     has no presentation photo, so they always resolve to the shared fallback tile —
     never a blank preview). Arrow keys just move focus between the links; the focus
     handler below does the actual swap, so keyboard behaves exactly like hover. */
  function initOccPreview(root){
    Array.prototype.forEach.call(root.querySelectorAll('[data-c9h-occ-list]'),function(list){
      var grid=list.closest('.c9h-occ__grid');
      var lid=grid&&grid.querySelector('[data-c9h-occ-lid]');
      if(!lid) return;
      var links=Array.prototype.slice.call(list.querySelectorAll('.c9h-occ__link'));
      var tiles=Array.prototype.slice.call(lid.querySelectorAll('[data-c9h-occ-for]'));
      function show(key){
        var hit=false;
        tiles.forEach(function(el){
          var on=el.getAttribute('data-c9h-occ-for')===key;
          if(on) hit=true;
          el.classList.toggle('is-active',on);
        });
        if(!hit){
          tiles.forEach(function(el){el.classList.toggle('is-active',el.getAttribute('data-c9h-occ-for')==='');});
        }
      }
      links.forEach(function(a,i){
        var key=a.getAttribute('data-c9h-occ-key')||'';
        a.addEventListener('mouseenter',function(){show(key);});
        a.addEventListener('focus',function(){show(key);});
        a.addEventListener('keydown',function(e){
          if(e.key==='ArrowDown'){e.preventDefault();(links[i+1]||links[0]).focus();}
          else if(e.key==='ArrowUp'){e.preventDefault();(links[i-1]||links[links.length-1]).focus();}
        });
      });
    });
  }

  /* ---------- open-now pill (live Karachi time vs boutique hours) ---------- */
  function mins(v){var m=/^\s*(\d{1,2})[:.](\d{2})\s*$/.exec(v||'');if(!m)return null;var h=+m[1],n=+m[2];if(h>24||n>59)return null;return (h%24)*60+n;}
  function t12(t){var h=Math.floor(t/60)%24,m=t%60;return ((h%12)||12)+(m?':'+String(m).padStart(2,'0'):'')+(h<12?' AM':' PM');}
  function karachiNow(){
    try{
      var p={};new Intl.DateTimeFormat('en-GB',{timeZone:'Asia/Karachi',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(new Date()).forEach(function(x){p[x.type]=x.value;});
      return (+p.hour%24)*60+(+p.minute);
    }catch(e){var n=new Date();return ((n.getUTCHours()+5)%24)*60+n.getUTCMinutes();}  /* PKT is UTC+5, no DST */
  }
  function initPill(root){
    var pill=root.querySelector('[data-c9h-pill]'),cfgEl=root.querySelector('[data-c9h-hours]');
    var sid=root.getAttribute('data-section-id');
    if(timers[sid]){clearInterval(timers[sid]);delete timers[sid];}
    if(!pill||!cfgEl) return;
    var cfg;try{cfg=JSON.parse(cfgEl.textContent);}catch(e){return;}
    var bs=(cfg.boutiques||[]).map(function(b){return {n:(b.name||'').trim(),o:mins(b.open),c:mins(b.close)};}).filter(function(b){return b.n&&b.o!=null&&b.c!=null&&b.o!==b.c;});
    if(!bs.length) return;
    var txt=pill.querySelector('[data-c9h-pill-text]');
    function paint(){
      var t=karachiNow(),open=null;
      for(var i=0;i<bs.length;i++){var b=bs[i];if(b.c>b.o?(t>=b.o&&t<b.c):(t>=b.o||t<b.c)){open=b;break;}}
      var s;
      if(open){s=String(cfg.open||'[name] open · till [time]').replace('[name]',open.n).replace('[time]',t12(open.c));}
      else{
        var next=bs.slice().sort(function(a,b){return ((a.o-t+1440)%1440)-((b.o-t+1440)%1440);})[0];
        s=String(cfg.closed||'Opens [time]').replace('[name]',next.n).replace('[time]',t12(next.o));
      }
      txt.textContent=s;
      pill.classList.toggle('is-closed',!open);
      pill.setAttribute('aria-label',s+'. Boutique hours and addresses');
      pill.hidden=false;
    }
    paint();
    timers[sid]=setInterval(paint,60000);
  }

  /* ---------- search overlay (Shopify predictive search) ---------- */
  function money(v){var n=Math.round(parseFloat(v)||0);return 'Rs '+n.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');}
  function sized(u,w){if(!u)return '';return u+(u.indexOf('?')>-1?'&':'?')+'width='+w;}
  function cardHTML(p,bestTag,newTag){
    var tags=(p.tags||[]).map(function(t){return String(t).toLowerCase();});
    var bdg=tags.indexOf(bestTag)>-1?'Bestseller':(newTag&&tags.indexOf(newTag)>-1?'New':'');
    var fi=p.featured_image||{};var src=fi.url||p.image||'';var alt=fi.alt||p.title;
    var lo=parseFloat(p.price_min||p.price),hi=parseFloat(p.price_max||p.price);
    var img=src?'<img src="'+esc(sized(src,480))+'" srcset="'+esc(sized(src,240))+' 240w, '+esc(sized(src,360))+' 360w, '+esc(sized(src,480))+' 480w" sizes="(min-width: 1120px) 220px, (min-width: 600px) 30vw, 45vw" alt="'+esc(alt)+'" loading="lazy" width="480" height="600">':'';
    return '<a class="c9h-card" href="'+esc(p.url)+'"><span class="c9h-card__frame">'+img+(bdg?'<span class="c9h-card__bdg'+(bdg==='Bestseller'?' is-gold':'')+'">'+bdg+'</span>':'')+'</span>'+
      '<span class="c9h-card__meta"><b>'+esc(p.title)+'</b><span class="c9h-card__pr">'+(hi>lo?'From ':'')+money(lo)+'</span></span></a>';
  }
  function initSearch(el){
    if(!el||el._c9hInit) return; el._c9hInit=true;
    var input=el.querySelector('[data-c9h-q]'),form=input&&input.form,def=el.querySelector('[data-c9h-sdefault]'),res=el.querySelector('[data-c9h-sresults]'),status=el.querySelector('[data-c9h-status]');
    var tNone=el.querySelector('template[data-c9h-snone]'),tAll=el.querySelector('template[data-c9h-sall]');
    var url=el.getAttribute('data-suggest-url')||'/search/suggest.json';
    var bestTag=(el.getAttribute('data-best-tag')||'bestseller').toLowerCase(),newTag=(el.getAttribute('data-new-tag')||'').toLowerCase();
    var searchUrl=(form&&form.getAttribute('action'))||'/search';
    var timer=null,ctrl=null,last='';
    if(!input||!res) return;
    function allLink(q){
      if(!tAll) return '';
      var a=tAll.content.firstElementChild.cloneNode(true);
      a.setAttribute('href',searchUrl+'?q='+encodeURIComponent(q)+'&type=product&options%5Bprefix%5D=last');
      var box=d.createElement('div');box.appendChild(a);return box.innerHTML;
    }
    function showDefault(){res.hidden=true;res.innerHTML='';if(def)def.hidden=false;if(status)status.textContent='';}
    function rowsHTML(cols,qs){
      var h='';
      if(cols&&cols.length) h+='<p class="c9-kick c9h-srch__kick">Collections</p><div class="c9h-srows">'+cols.slice(0,4).map(function(c){return '<a class="c9h-srow" href="'+esc(c.url)+'">'+esc(c.title)+'</a>';}).join('')+'</div>';
      if(qs&&qs.length) h+='<p class="c9-kick c9h-srch__kick">Suggestions</p><div class="c9h-srows">'+qs.slice(0,4).map(function(x){return '<button type="button" class="c9h-srow c9h-srow--q" data-c9h-fill="'+esc(x.text)+'">'+esc(x.text)+'</button>';}).join('')+'</div>';
      return h;
    }
    function render(list,q,cols,qs){
      if(def) def.hidden=true;
      res.hidden=false;res.classList.remove('c9h-srch__busy');
      var extra=rowsHTML(cols,qs);
      if(list.length){
        var n=list.length,label=n>=10?'Top 10 matches':(n+' result'+(n>1?'s':''));
        res.innerHTML=extra+'<p class="c9-kick c9h-srch__kick">'+label+'</p><div class="c9h-sres c9h-sres--found">'+list.map(function(p){return cardHTML(p,bestTag,newTag);}).join('')+'</div>'+allLink(q);
        if(status) status.textContent=label+' for '+q;
      }else{
        res.innerHTML=extra+(tNone?tNone.innerHTML:'');
        if(status) status.textContent='No matches for '+q;
      }
    }
    function run(q){
      if(ctrl&&ctrl.abort) ctrl.abort();
      ctrl=W.AbortController?new AbortController():null;
      res.classList.add('c9h-srch__busy');
      /* Q5: products, collections AND query suggestions; Q2: greeting cards and
         packaging are not gifts — they never surface here (the box builder and
         the product page still reach them by collection). */
      var qs='?q='+encodeURIComponent(q)+'&resources%5Btype%5D=product,collection,query&resources%5Blimit%5D=10&resources%5Blimit_scope%5D=each&resources%5Boptions%5D%5Bunavailable_products%5D=last&resources%5Boptions%5D%5Bfields%5D=title,product_type,variants.title,tag,vendor';
      fetch(url+qs,{credentials:'same-origin',headers:{'Accept':'application/json'},signal:ctrl?ctrl.signal:undefined})
        .then(function(r){if(!r.ok)throw new Error(r.status);return r.json();})
        .then(function(j){
          if(input.value.trim()!==q) return;           /* a newer query is on its way */
          var res=(j&&j.resources&&j.resources.results)||{};
          var hideTypes=['greeting card','packaging'];
          var list=(res.products||[]).filter(function(p){return hideTypes.indexOf(String(p.type||p.product_type||'').toLowerCase())<0;});
          render(list,q,res.collections||[],res.queries||[]);
        })
        .catch(function(err){
          if(err&&err.name==='AbortError') return;
          if(input.value.trim()!==q) return;
          if(def) def.hidden=true;
          res.hidden=false;res.classList.remove('c9h-srch__busy');
          res.innerHTML=allLink(q);                      /* offline / error: the full search page still works */
        });
    }
    input.addEventListener('input',function(){
      var q=input.value.trim();
      clearTimeout(timer);
      if(q===last) return;
      last=q;
      if(!q){if(ctrl&&ctrl.abort)ctrl.abort();showDefault();return;}
      timer=setTimeout(function(){run(q);},180);
    });
    if(form) form.addEventListener('submit',function(e){if(!input.value.trim()){e.preventDefault();input.focus();}});
    el.addEventListener('click',function(e){
      var f=e.target.closest&&e.target.closest('[data-c9h-fill]');
      if(!f) return;
      e.preventDefault();
      input.value=f.getAttribute('data-c9h-fill')||f.textContent.trim();
      input.focus();
      try{input.setSelectionRange(input.value.length,input.value.length);}catch(x){}
      last=input.value.trim();clearTimeout(timer);run(last);
    });
  }

  /* ---------- bag count badge: hidden while it reads 0, pulses once on a real change (Job D) ---------- */
  function initCount(root){
    Array.prototype.forEach.call(root.querySelectorAll('.c9h-cnt[data-cart-count]'),function(c){
      function sync(){
        var n=parseInt(c.textContent,10)||0;
        c.classList.toggle('is-zero',n<1);
        var b=c.closest('a');if(b)b.setAttribute('aria-label',n?'Your bag, '+n+' item'+(n>1?'s':''):'Your bag');
        if(c._c9hPrevN!==undefined&&c._c9hPrevN!==n){
          c.classList.remove('is-pulse');
          void c.offsetWidth; /* restart the animation if it changes twice in quick succession */
          c.classList.add('is-pulse');
        }
        c._c9hPrevN=n;
      }
      sync();
      if('MutationObserver' in W) new MutationObserver(sync).observe(c,{childList:true,characterData:true,subtree:true});
    });
  }

  /* ---------- init / theme editor ---------- */
  function init(root){
    if(!root||root._c9hInit) return; root._c9hInit=true;
    var sec=root.closest('.shopify-section')||root.parentNode;
    var sid=root.getAttribute('data-section-id');
    if(root.classList.contains('c9h--sticky')&&sec&&sec!==d.body) sec.classList.add('c9h-sticky');
    ['data-c9h-search','data-c9h-menu'].forEach(function(attr){
      var fresh=sec?sec.querySelector('['+attr+']'):null;
      Array.prototype.forEach.call(d.querySelectorAll('body > ['+attr+']'),function(n){if(n!==fresh&&n.getAttribute('data-c9h-owner')===sid)n.remove();});
      if(fresh) d.body.appendChild(fresh);
    });
    initMega(root);initOccPreview(root);initPill(root);initCount(root);initSearch(searchEl());
  }
  /* Q3 (audit): the phone search overlay (header.liquid [data-c9x-search]) gets
     the same predictive engine as the desktop one. Its markup only has a form
     and an input, so the hooks initSearch() needs are added here, once, and
     the hidden type=product keeps pages and posts out of the results. */
  function initPhoneSearch(){
    var ph=d.querySelector('[data-c9x-search]');
    if(!ph||ph._c9hInit) return;
    var input=ph.querySelector('[data-c9x-q]'),form=input&&input.form;
    if(!input||!form) return;
    var deskSrch=searchEl();
    input.setAttribute('data-c9h-q','');
    if(!form.querySelector('input[name="type"]')){var t=d.createElement('input');t.type='hidden';t.name='type';t.value='product';form.appendChild(t);}
    if(!form.querySelector('input[name="options[prefix]"]')){var pf=d.createElement('input');pf.type='hidden';pf.name='options[prefix]';pf.value='last';form.appendChild(pf);}
    var st=d.createElement('p');st.className='c9h-sr-only';st.setAttribute('role','status');st.setAttribute('aria-live','polite');st.setAttribute('data-c9h-status','');
    var hints=form.querySelector('.c9-srch__hints');
    var def=d.createElement('div');def.setAttribute('data-c9h-sdefault','');
    if(hints){hints.parentNode.insertBefore(def,hints);def.appendChild(hints);}else{form.appendChild(def);}
    var out=d.createElement('div');out.setAttribute('data-c9h-sresults','');out.hidden=true;out.className='c9h-srch__inner c9-srch__results';
    def.parentNode.insertBefore(out,def.nextSibling);
    form.appendChild(st);
    if(deskSrch){
      ['data-c9h-snone','data-c9h-sall'].forEach(function(a){var tpl=deskSrch.querySelector('template['+a+']');if(tpl) form.appendChild(tpl.cloneNode(true));});
      ph.setAttribute('data-suggest-url',deskSrch.getAttribute('data-suggest-url')||'/search/suggest.json');
      ph.setAttribute('data-best-tag',deskSrch.getAttribute('data-best-tag')||'bestseller');
      ph.setAttribute('data-new-tag',deskSrch.getAttribute('data-new-tag')||'');
    }
    Array.prototype.forEach.call(form.querySelectorAll('.c9-srch__hint'),function(a){a.setAttribute('data-c9h-fill',a.textContent.trim());});
    initSearch(ph);
  }
  function boot(){Array.prototype.forEach.call(d.querySelectorAll('[data-c9h]'),init);initPhoneSearch();}
  if(d.readyState!=='loading'){boot();}else{d.addEventListener('DOMContentLoaded',boot);}
  d.addEventListener('shopify:section:load',function(e){var r=e.target&&e.target.querySelector&&e.target.querySelector('[data-c9h]');if(r){current=null;html.classList.remove('c9h-lock');init(r);}});
  d.addEventListener('shopify:section:unload',function(e){
    var r=e.target&&e.target.querySelector&&e.target.querySelector('[data-c9h]');if(!r) return;
    var sid=r.getAttribute('data-section-id');
    if(timers[sid]){clearInterval(timers[sid]);delete timers[sid];}
    Array.prototype.forEach.call(d.querySelectorAll('body > [data-c9h-owner="'+sid+'"]'),function(n){n.remove();});
    current=null;html.classList.remove('c9h-lock');
  });
  W.C9Header={openSearch:function(){openSearch(null);},openMenu:function(){openMenu(null);},close:function(){if(current)closeLayer(current,true);}};
})();

/* Product tile two-angle image pair (snippets/c9-img-pair.liquid).
   The crossfade itself is pure CSS (:hover / .is-active in coco9-ux.css).
   This just runs the two bits CSS can't: a tap on the dots button toggles
   the angle without navigating the tile link, and tabbing onto the tile
   (or its dots button) shows the second angle the same way hover does.
   One delegated listener set for the whole page — guarded so a second
   copy of this file can never attach it twice. */
(function(){
  if(window.__c9PairInit) return;
  window.__c9PairInit=true;
  var d=document;
  function findPair(el){
    if(!el) return null;
    var p=el.closest&&el.closest('[data-c9-pair]');
    if(p) return p;
    return el.querySelector&&el.querySelector('[data-c9-pair]');
  }
  d.addEventListener('click',function(e){
    var btn=e.target.closest&&e.target.closest('[data-c9-pair-toggle]');
    if(!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var pair=btn.closest('[data-c9-pair]');
    if(!pair) return;
    var next=btn.getAttribute('aria-pressed')!=='true';
    pair.classList.toggle('is-active',next);
    btn.setAttribute('aria-pressed',next?'true':'false');
  });
  d.addEventListener('focusin',function(e){
    var pair=findPair(e.target);
    if(pair) pair.classList.add('is-active');
  });
  d.addEventListener('focusout',function(e){
    var pair=findPair(e.target);
    if(pair) pair.classList.remove('is-active');
  });

  /* On touch devices there is no hover, so the second angle would only ever
     show behind a tap. Instead, as a tile settles into the middle of the
     screen it eases to the second angle, and eases back as it leaves — the
     same reward hover gives on desktop, delivered by scrolling. Desktop and
     reduced-motion are untouched; a tile the visitor has toggled by hand is
     left alone. */
  var noHover=window.matchMedia&&window.matchMedia('(hover: none)').matches;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(noHover&&!reduce&&'IntersectionObserver' in window){
    var timers=new WeakMap();
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        var pair=en.target;
        var btn=pair.querySelector('[data-c9-pair-toggle]');
        if(btn&&btn.getAttribute('aria-pressed')==='true') return; /* hand-toggled: leave it */
        var t=timers.get(pair); if(t){clearTimeout(t);timers.delete(pair);}
        if(en.isIntersecting&&en.intersectionRatio>=0.85){
          timers.set(pair,setTimeout(function(){pair.classList.add('is-active');},420));
        }else{
          pair.classList.remove('is-active');
        }
      });
    },{threshold:[0,0.85],rootMargin:'-18% 0px -18% 0px'});
    var seen=new WeakSet();
    function watch(){
      Array.prototype.forEach.call(d.querySelectorAll('[data-c9-pair]'),function(p){
        if(seen.has(p)) return; seen.add(p); io.observe(p);
      });
    }
    /* this file loads in <head>: the body does not exist yet, so wait for it
       before observing tiles or watching for late-arriving ones */
    function arm(){
      watch();
      new MutationObserver(function(){watch();}).observe(d.body,{childList:true,subtree:true});
    }
    if(d.body) arm(); else d.addEventListener('DOMContentLoaded',arm);
  }
})();

/* Hero reveal: pure CSS since audit X4 (2026-09-24) — see coco9-ux.css
   `html.c9-js main h1{animation:…}`. Nothing here gates the H1 any more, so
   text LCP no longer waits for this deferred file. */

/* Announcement bar — quiet session dismissal (Job D, 2026-09-22).
   Progressive enhancement only: adds a close control and remembers the
   dismissal for this browser session (sessionStorage). Without JS, or if
   storage is blocked/full, the bar behaves exactly as it always has —
   always shown, no close button, nothing to get stuck half-dismissed. */
(function(){
  var d=document;
  function run(){
    var bar=d.querySelector('[data-anno]');
    if(!bar||bar._c9annoInit) return;
    bar._c9annoInit=true;
    var ss=null; try{ ss=window.sessionStorage; }catch(e){}
    var KEY='c9-anno-dismissed';
    if(ss){ try{ if(ss.getItem(KEY)==='1'){ if(bar.parentNode) bar.parentNode.removeChild(bar); return; } }catch(e){} }
    var inner=bar.querySelector('.c9-anno__inner')||bar;
    var btn=d.createElement('button');
    btn.type='button';
    btn.className='c9-anno__x';
    btn.setAttribute('aria-label','Dismiss this message');
    btn.innerHTML='<svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    inner.appendChild(btn);
    bar.classList.add('c9-anno--dismissible');
    btn.addEventListener('click',function(){
      if(ss){ try{ ss.setItem(KEY,'1'); }catch(e){} }
      bar.classList.add('c9-anno--out');
      setTimeout(function(){ if(bar.parentNode) bar.parentNode.removeChild(bar); },220);
    });
  }
  if(d.readyState!=='loading'){run();}else{d.addEventListener('DOMContentLoaded',run);}
})();

/* =====================================================================
   COCO 9 ANALYTICS (audit N1, 2026-09-24)
   One function: window.c9track(name, data) → Shopify.analytics.publish.
   A custom pixel (Settings → Customer events, code in
   docs/website-redesign-2026-09/custom-pixel.js) subscribes to these names
   and forwards them to GA4, Google Ads and Meta. Nothing in the theme calls
   gtag/fbq directly any more: those globals do not exist inside Shopify's
   web-pixel sandbox, so they were silent.
   Events fired by the theme: whatsapp_click (below, delegated), corporate_inquiry,
   wedding_inquiry, personalization_started / _completed, delivery_slot_selected,
   build_a_gift_started / _completed, gift_finder_completed, whatsapp_optin,
   newsletter_signup. Each fires at most once per page for the "started" kind.
   ===================================================================== */
(function(){
  var d=document,once={};
  function track(name,data){
    try{
      var payload=data||{};
      payload.page_type=payload.page_type||(d.body&&d.body.className.match(/template-([\w-]+)/)||[])[1]||'';
      if(window.Shopify&&Shopify.analytics&&typeof Shopify.analytics.publish==='function') Shopify.analytics.publish(name,payload);
      if(window.dataLayer) window.dataLayer.push(Object.assign({event:name},payload));
    }catch(e){}
  }
  function trackOnce(name,data){ if(once[name]) return; once[name]=1; track(name,data); }
  window.c9track=track; window.c9trackOnce=trackOnce;
  function intentFor(a){
    var h=(a.getAttribute('href')||'').toLowerCase(),t=(a.textContent||'').toLowerCase();
    var s=(a.closest('[data-c9-track-surface]')||{}).getAttribute? (a.closest('[data-c9-track-surface]').getAttribute('data-c9-track-surface')):'';
    if(/photo|picture|logo/.test(h)||/photo/.test(t)) return 'cake_photo';
    if(/corporate|brief|company/.test(h)||/corporate/.test(t)||/cor-/.test(a.className)) return 'corporate';
    if(/wedding|dessert table|mehndi|valima/.test(h)||/wedding/.test(t)||/we[mp]-/.test(a.className)) return 'wedding';
    if(/cake/.test(h)) return 'cake';
    return s||'general';
  }
  d.addEventListener('click',function(e){
    var a=e.target.closest&&e.target.closest('a[href*="wa.me"],a[href*="whatsapp.com"],a[href^="whatsapp:"]');
    if(!a) return;
    var sec=a.closest('.shopify-section,[data-section-id]');
    track('whatsapp_click',{surface:sec?(sec.id||sec.getAttribute('data-section-id')||''):'', intent:intentFor(a), href:a.getAttribute('href')||''});
  },{capture:true});
})();

/* =====================================================================
   Horizontal rails — swipe cue for phones (2026-10-17).
   Raj: "how will customers know to scroll over on mobile?" Any row that
   scrolls sideways on a phone (cake cards, chips, occasion tiles) gets a
   slim progress bar under it; card-height rails also get a "Swipe" nudge
   that fades the first time the row moves. Nothing is added on desktop,
   inside the header, drawers or pop-ups, and rows that fit get nothing.
   ===================================================================== */
(function(){
  var d=document;
  var mq=window.matchMedia?window.matchMedia('(max-width: 860px)'):{matches:true};
  var SKIP='header,.c9h,[data-cart-drawer],.cart-drawer,.c9club,.c9-say-it,.cdr,nav,[data-c9-norail]';
  function isRail(el){
    if(el.__c9rail) return false;
    if(el.closest&&el.closest(SKIP)) return false;
    var cs=getComputedStyle(el), ox=cs.overflowX;
    if(ox!=='auto'&&ox!=='scroll') return false;
    if(el.children.length<2||el.clientHeight<28) return false;
    return el.scrollWidth>el.clientWidth+24;
  }
  function build(el){
    el.__c9rail=true;
    var h=d.createElement('div'); h.className='c9-rail'; h.setAttribute('aria-hidden','true');
    var big=el.clientHeight>120;
    h.innerHTML='<span class="c9-rail__track"><span class="c9-rail__thumb"></span></span>'+(big?'<span class="c9-rail__hint">Swipe<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8h10M9 4l4 4-4 4"/></svg></span>':'');
    el.insertAdjacentElement('afterend',h);
    var th=h.querySelector('.c9-rail__thumb'), moved=false, raf=0;
    function paint(){
      raf=0;
      var max=el.scrollWidth-el.clientWidth;
      if(max<=24||!mq.matches){h.hidden=true;return;}
      h.hidden=false;
      var w=Math.max(18,Math.min(80,Math.round(el.clientWidth/el.scrollWidth*100)));
      var r=Math.max(0,Math.min(1,el.scrollLeft/max));
      th.style.width=w+'%';
      th.style.transform='translateX('+(r*(100-w)/w*100)+'%)';
      if(!moved&&el.scrollLeft>8){moved=true;h.classList.add('is-moved');}
    }
    function onScroll(){ if(!raf) raf=requestAnimationFrame(paint); }
    el.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',onScroll);
    paint();
  }
  var scanned=false;
  function scan(){
    if(!mq.matches) return;
    var root=d.querySelector('main')||d.body;
    Array.prototype.forEach.call(root.querySelectorAll('ul,ol,div,section'),function(el){ if(isRail(el)) build(el); });
    scanned=true;
  }
  function boot(){ scan(); setTimeout(scan,1200); window.addEventListener('load',function(){ setTimeout(scan,300); }); }
  if(d.readyState==='loading') d.addEventListener('DOMContentLoaded',boot); else boot();
  if(mq.addEventListener) mq.addEventListener('change',function(){ if(mq.matches&&!scanned) scan(); window.dispatchEvent(new Event('resize')); });
})();
